import { Project } from '../types'
import { apiRequestWithAutoRefresh } from '../utils/apiUtils'

export const projectService = {
  // 取得專案列表
  async getProjects(params?: {
    isActive?: boolean
    search?: string
  }): Promise<Project[]> {
    const searchParams = new URLSearchParams()
    
    if (params?.isActive !== undefined) {
      searchParams.append('isActive', params.isActive.toString())
    }
    if (params?.search) {
      searchParams.append('search', params.search)
    }

    const result = await apiRequestWithAutoRefresh(
      `/projects?${searchParams.toString()}`,
      { method: 'GET' }
    )
    return result.data
  },

  // 取得單一專案詳情
  async getProject(projectId: string): Promise<Project> {
    const result = await apiRequestWithAutoRefresh(
      `/projects/${projectId}`,
      { method: 'GET' }
    )
    return result.data
  },

  // 建立新專案
  async createProject(data: {
    name: string
    description?: string
    color?: string
    budgetType?: 'monthly' | 'total'
    budgetAmount?: number
    showBudgetToMembers?: boolean
    memberIds?: string[]
  }): Promise<Project> {
    const result = await apiRequestWithAutoRefresh(
      `/projects`,
      {
        method: 'POST',
        body: JSON.stringify(data)
      }
    )
    return result.data
  },

  // 更新專案
  async updateProject(
    projectId: string,
    data: {
      name?: string
      description?: string
      color?: string
      isActive?: boolean
      memberIds?: string[]
      budgetType?: 'monthly' | 'total'
      budgetAmount?: number
      showBudgetToMembers?: boolean
    }
  ): Promise<Project> {
    const result = await apiRequestWithAutoRefresh(
      `/projects/${projectId}`,
      {
        method: 'PUT',
        body: JSON.stringify(data)
      }
    )
    return result.data
  },

  // 刪除專案
  async deleteProject(projectId: string): Promise<void> {
    await apiRequestWithAutoRefresh(
      `/projects/${projectId}`,
      { method: 'DELETE' }
    )
  },

  // 新增專案成員
  async addMembers(projectId: string, userIds: string[]): Promise<void> {
    await apiRequestWithAutoRefresh(
      `/projects/${projectId}/members`,
      {
        method: 'POST',
        body: JSON.stringify({ userIds })
      }
    )
  },

  // 移除專案成員
  async removeMember(projectId: string, userId: string): Promise<void> {
    await apiRequestWithAutoRefresh(
      `/projects/${projectId}/members/${userId}`,
      { method: 'DELETE' }
    )
  },

  // 獲取最近最常使用的專案
  async getRecentFavoriteProjects(): Promise<Project[]> {
    const result = await apiRequestWithAutoRefresh(
      `/projects/recent-favorites`,
      { method: 'GET' }
    )
    return result.data
  }
}
